import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.sass'],
  standalone: true,
  imports: []
})
export class NotFoundComponent implements OnInit {
  redirectUrl = environment.redirectUrl;

  constructor() {
  }

  onSubmit() {
  }

  ngOnInit() {
    const loader = document.getElementById("loader-container")
    loader!.style.display = "none";
  }
}